import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "35932428-2464-4112-a641-9c7a3c3eabfd",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2936f649-5d9e-494c-8b2f-ebe2948e1123",
      type: "NineSlicePlane",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 445,
        y: 301
      },
      width: 890,
      height: 602,
      leftWidth: 100,
      topHeight: 300,
      rightWidth: 102,
      bottomHeight: 273,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "mission_board",
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "d0d1b581-3766-4bb7-9760-c13780a84730",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 426,
      y: -229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "btn_close",
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "75d6e23c-4dc5-46f0-8c09-1a0095ae812c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -281,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "offer_popup_title_back",
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "506f8522-4c0d-4791-9989-44d0446fe032",
      type: "Text",
      name: "title",
      nameSpace: "",
      className: "",
      x: -4,
      y: -294,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "LIMITED TIME OFFER",
      localize: false,
      maxWidth: 315,
      maxHeight: 137,
      maxFontSize: 54,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#FFFFFF",
        stroke: "#692012",
        strokeThickness: 10,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: -19,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 3
      },
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "c2efe232-44aa-47bb-89b0-eb847052ad61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -10,
      y: -207,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "offer_icon_timer_large",
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "d5c3443b-ef15-4e4a-b14e-bae58de5217f",
      type: "Text",
      name: "timeText",
      nameSpace: "",
      className: "",
      x: 12,
      y: -208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "22:23:19",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#FFFFFF",
        stroke: "#692012",
        strokeThickness: 4,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "5465aaa4-3bd6-42a1-a263-caafd1e25cfa",
      type: "Container",
      name: "armatureContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 30,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "b0c6cc53-8eb8-4efe-b075-36fe5166c942",
      type: "Container",
      name: "labelsContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "603dd4ee-1353-48a0-8082-0c613c2cc792",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_bg",
      parent: "35932428-2464-4112-a641-9c7a3c3eabfd",
      data: ""
    },
    {
      id: "d1f7f86f-79ab-42d6-bca6-21a01b83d94f",
      type: "Text",
      name: "coinsText",
      nameSpace: "",
      className: "",
      x: -192,
      y: 72,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "250,000",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: "normal",
        fontFamily: "RobotoBlack",
        fill: "#FFFFFF",
        stroke: "#921612",
        strokeThickness: 8,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 3
      },
      parent: "b0c6cc53-8eb8-4efe-b075-36fe5166c942",
      data: ""
    },
    {
      id: "69e0fdca-3487-4c8b-ab11-8c4eec43d3ed",
      type: "Text",
      name: "jokerText",
      nameSpace: "",
      className: "",
      x: 33,
      y: 74,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x10",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: "normal",
        fontFamily: "RobotoBlack",
        fill: "#FFFFFF",
        stroke: "#921612",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b0c6cc53-8eb8-4efe-b075-36fe5166c942",
      data: ""
    },
    {
      id: "fe8f95e1-fead-4abe-83e5-c20a8b9b3ad3",
      type: "Text",
      name: "plusFiveText",
      nameSpace: "",
      className: "",
      x: 157,
      y: 74,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x10",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: "normal",
        fontFamily: "RobotoBlack",
        fill: "#FFFFFF",
        stroke: "#921612",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b0c6cc53-8eb8-4efe-b075-36fe5166c942",
      data: ""
    },
    {
      id: "30a8590c-afee-4208-af5a-5d9ca7bece4b",
      type: "Text",
      name: "undoText",
      nameSpace: "",
      className: "",
      x: 282,
      y: 74,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "x10",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: "normal",
        fontFamily: "RobotoBlack",
        fill: "#FFFFFF",
        stroke: "#921612",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b0c6cc53-8eb8-4efe-b075-36fe5166c942",
      data: ""
    },
    {
      id: "30f009e3-f976-4895-a12e-86b73d417435",
      type: "Sprite",
      name: "buyButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "603dd4ee-1353-48a0-8082-0c613c2cc792",
      data: ""
    },
    {
      id: "22e6ea92-89e1-4658-a70c-d0865f755d5f",
      type: "Text",
      name: "oldPrice",
      nameSpace: "",
      className: "",
      x: 0,
      y: -32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "$ 31.99",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#FFFFFF",
        stroke: "#17762E",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "30f009e3-f976-4895-a12e-86b73d417435",
      data: ""
    },
    {
      id: "80c3e7d7-6f6a-400f-9d2e-3bc084aa0d2d",
      type: "Text",
      name: "strike",
      nameSpace: "",
      className: "",
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 6,
        y: 1
      },
      angle: -15,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "━",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ff075a",
        stroke: "#17762E",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "30f009e3-f976-4895-a12e-86b73d417435",
      data: ""
    },
    {
      id: "f3b6207e-e4f2-485d-96bf-5e4182a42825",
      type: "Text",
      name: "priceText",
      nameSpace: "",
      className: "",
      x: 0,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "$ 14.99",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: "normal",
        fontFamily: "ArchivoBlack",
        fill: "#FFF600",
        stroke: "#17762E",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "30f009e3-f976-4895-a12e-86b73d417435",
      data: ""
    }
  ]
} as const;

export class PayerReactivationLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  bg: GameObject<PIXI.NineSlicePlane>;
  closeButton: GameObject<PIXI.Sprite>;
  title: GameObject<PIXI.Text>;
  timeText: GameObject<PIXI.Text>;
  armatureContainer: GameObject<PIXI.Container>;
  labelsContainer: GameObject<PIXI.Container>;
  coinsText: GameObject<PIXI.Text>;
  jokerText: GameObject<PIXI.Text>;
  plusFiveText: GameObject<PIXI.Text>;
  undoText: GameObject<PIXI.Text>;
  buyButton: GameObject<PIXI.Sprite>;
  oldPrice: GameObject<PIXI.Text>;
  strike: GameObject<PIXI.Text>;
  priceText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
